const Icon = () => (
  <svg
    width="40"
    height="34"
    viewBox="0 0 40 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="18" width="8" height="16" rx="4" fill="#575BFD" />
    <rect x="16" y="11" width="8" height="23" rx="4" fill="#575BFD" />
    <rect x="32" width="8" height="34" rx="4" fill="#575BFD" />
  </svg>
);

export default Icon;
